module.exports = __webpack_public_path__ + "static/img/score-mobile-5.3fb6ed34.png";